import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getCustomerRegion = createAsyncThunk(
  "admin/customer-region",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/customer-region", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getCustomerRegionById = createAsyncThunk(
  "admin/customer-region/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/customer-region/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortCustomerRegion = createAsyncThunk(
  "admin/customer-region/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/customer-region/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postCustomerRegion = createAsyncThunk(
  "admin/customer-region/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/customer-region", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteCustomerRegion = createAsyncThunk(
  "admin/customer-region/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/customer-region/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateCustomerRegion = createAsyncThunk(
  "admin/customer-region/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/customer-region/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const customerRegionSlice = createSlice({
  name: "Customer Region Store",
  initialState: initialState,
  reducers: {
    addCustomerRegion(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortCustomerRegion(state, action) {
      state.data.docs = action.payload;
    },
    deleteCustomerRegion(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editCustomerRegion(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getCustomerRegion.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomerRegion.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getCustomerRegion.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerRegionById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomerRegionById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerRegionById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomerRegion.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortCustomerRegion.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomerRegion.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postCustomerRegion.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postCustomerRegion.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postCustomerRegion.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteCustomerRegion.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteCustomerRegion.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteCustomerRegion.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateCustomerRegion.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateCustomerRegion.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateCustomerRegion.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const customerRegionActions = customerRegionSlice.actions;

export default customerRegionSlice.reducer;
